module.exports = __webpack_public_path__ + "static/media/14.dropbox.304530c4.svg";